<ng-content></ng-content>
<i style="float:right" class="fa fa-chevron-up" *ngIf="sortDirection === 'asc'" ></i>
<i style="float:right" class="fa fa-chevron-down" *ngIf="sortDirection === 'desc'"></i>
